import React from 'react'
import Header from '../Header'

const Recorded = () => {
  return (
    <div>
        <Header/>
        Recorded
    </div>
  )
}

export default Recorded